const ISSUER_ID_STORAGE_KEY = "issuer_selected_id";
const ISSUER_CARD_NUMBER_STORAGE_KEY = "issuer_card_number_filter";
const DEFAULT_SORT_COLUMN_FETCH_ISSUERS = "companyName";

export{
  ISSUER_ID_STORAGE_KEY,
  ISSUER_CARD_NUMBER_STORAGE_KEY,
  DEFAULT_SORT_COLUMN_FETCH_ISSUERS
}
